// extracted by mini-css-extract-plugin
module.exports = {"container":"_c7ab4ae3","form":"_b7c3d552","input":"_a870af12","searchIconWrapper":"_92430752"};